import { createRoot } from 'react-dom/client';
import { toast } from 'react-toastify';
import App from './App';
import { loadSentry } from './sentry';
import { reloadAfterChunkError } from './router/useLazyRoutes';

import './scss/fontello.scss';
import './scss/sitebase.scss';
import './index.css';

// Required for Vite hot reload - I cannot explain why it is needed!

export const R = () => {};

// Handle chunk load errors from React.lazy / Vite preload
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  toast.error('Something went wrong loading the page. Click to reload.', {
    autoClose: false,
    onClick: reloadAfterChunkError,
  });
});

if (import.meta.env.VITE_APP_SENTRY_DSN) {
  loadSentry();
}

// prevent warning msg on hot reload
const rootElement = document.getElementById('root');
if (!rootElement.__reactRoot) {
  rootElement.__reactRoot = createRoot(rootElement);
}
rootElement.__reactRoot.render(<App />);

// suppress react warnings
const originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0] && args[0]?.includes?.('will be removed')) {
    return;
  }
  originalConsoleError(...args);
};
